/* global Units */

import 'lib/units'

window['departments#new'] = function () {
  Units.addressesSelect()
  $('#department_unit_ids').change()
}

window['departments#edit'] = function () {
  Units.addressesSelect()
}

window['departments#index'] = function () {
  $('#current_unit_id').change(function (e) {
    const unitId = e.target.value
    window.location.href = `/units/${unitId}/departments`
  })
}

window['departments#show'] = function () {
  const tabName = $.ajaxSetup().url.split('#')[1]
  if (tabName?.length !== 0) {
    if ($('ul.edit-tabs li.active').children()[0].hash !== ('#' + tabName)) {
      $('a[href="#' + tabName + '"]').tab('show')
    }
  }
}
